import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLenis } from "lenis/react";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Services } from "@/components/site/Services";
import { About } from "@/components/site/About";
import { Testimonials } from "@/components/site/Testimonials";
import { Press } from "@/components/site/Press";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { usePageSeo } from "@/lib/seo";
// Reliable hash scrolling for a client-rendered SPA: the target section is
// mounted by React AFTER the browser's native fragment scroll, so we retry
// with lenis until the element exists (covers both full loads and SPA nav).
function useHashScroll() {
  const { hash } = useLocation();
  const lenis = useLenis();

  useEffect(() => {
    if (!hash) return;
    const id = hash.slice(1);
    let tries = 0;
    let raf;
    const attempt = () => {
      const el = document.getElementById(id);
      if (el) {
        if (lenis) lenis.scrollTo(el, { offset: -80, duration: 1.1 });
        else el.scrollIntoView({ behavior: "smooth" });
      } else if (tries++ < 30) {
        raf = setTimeout(attempt, 100);
      }
    };
    raf = setTimeout(attempt, 60);
    return () => clearTimeout(raf);
  }, [hash, lenis]);
}

export default function Landing() {
  useHashScroll();
  usePageSeo({
    path: "/",
    title: "Park Communications | Crisis PR & Reputation Management",
    description:
      "Park Communications is a boutique crisis PR firm helping executives, companies and public figures manage reputational threats before, during and after a crisis. Confidential consultations available.",
  });

  return (
    <main data-testid="landing-page">
      <Header />
      <Hero />
      <Services />
      <About />
      <Testimonials />
      <Press />
      <Contact />
      <Footer />
    </main>
  );
}
